/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetHelpArticleRequest} from '@cash-web/protos/squareup/cash/cashdotapp/api.pb'
import {GetHelpArticleResponse} from '@cash-web/protos/squareup/cash/cashdotapp/api.pb'


export const getHelpArticleCashDotApp = (request: GetHelpArticleRequest, options?: CashRequestOptions) => post<GetHelpArticleRequest, GetHelpArticleResponse>("/2.0/cash/get-help-article-cash-dot-app", request, {...options, rejectOnError: true })